import { render } from "./FavoriteView.vue?vue&type=template&id=bab26cc8&scoped=true"
import script from "./FavoriteView.vue?vue&type=script&lang=js"
export * from "./FavoriteView.vue?vue&type=script&lang=js"

import "./FavoriteView.vue?vue&type=style&index=0&id=bab26cc8&scoped=true&lang=css"
import "./FavoriteView.vue?vue&type=style&index=1&id=bab26cc8&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bab26cc8"]])

export default __exports__